(function () {
  var pinState = {
    pinned: null,
    height: null
  };

  var stickyInitialized = false;
  var rotateController = null;

  function isDrawerOpen() {
    var html = document.documentElement;
    return html.classList.contains('js-drawer-open') &&
      !html.classList.contains('js-drawer-open--search');
  }

  function shouldUnpinAnnouncement() {
    return isDrawerOpen() && window.matchMedia('(max-width: 768px)').matches;
  }

  function syncStickyHeaderHeight() {
    var wrap = document.getElementById('StickyHeaderWrap');
    var header = document.getElementById('SiteHeader');

    if (!wrap || !header || header.dataset.sticky !== 'true') {
      return;
    }

    wrap.style.height = header.offsetHeight + 'px';
  }

  function syncAnnouncementPinState() {
    var bar = document.querySelector('.announcement-bar');
    var header = document.getElementById('SiteHeader');
    var html = document.documentElement;

    if (!bar || !header) {
      return;
    }

    if (shouldUnpinAnnouncement()) {
      if (pinState.pinned !== false) {
        html.classList.remove('bdl-announcement-pinned');
        html.style.removeProperty('--bdl-announcement-h');
        pinState.pinned = false;
        pinState.height = null;
      }
      return;
    }

    var shouldPin = header.classList.contains('site-header--stuck');
    var height = shouldPin ? bar.offsetHeight + 'px' : null;

    if (pinState.pinned === shouldPin && pinState.height === height) {
      return;
    }

    pinState.pinned = shouldPin;
    pinState.height = height;

    if (shouldPin) {
      html.classList.add('bdl-announcement-pinned');
      html.style.setProperty('--bdl-announcement-h', height);
      syncStickyHeaderHeight();
      return;
    }

    html.classList.remove('bdl-announcement-pinned');
    html.style.removeProperty('--bdl-announcement-h');
    syncStickyHeaderHeight();
  }

  function handleDrawerVisibilityChange(drawerIsOpen) {
    pinState.pinned = null;

    if (!rotateController) {
      syncAnnouncementPinState();
      return;
    }

    if (drawerIsOpen) {
      rotateController.pauseForDrawer();
      syncAnnouncementPinState();
      return;
    }

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        rotateController.resumeFromDrawer();
      });
    });
  }

  function initAnnouncementRotate() {
    var slider = document.getElementById('AnnouncementSlider');
    if (!slider || slider.dataset.bdlAnnouncementRotateInit === 'true') {
      return false;
    }

    if (slider.dataset.blockCount === '1') {
      return false;
    }

    var slides = slider.querySelectorAll(':scope > .announcement-slider__slide');
    if (slides.length < 2) {
      return false;
    }

    var viewport = document.createElement('div');
    viewport.className = 'bdl-announcement-rotate__viewport';
    var track = document.createElement('div');
    track.className = 'bdl-announcement-rotate__track';

    slides.forEach(function (slide) {
      track.appendChild(slide);
    });

    viewport.appendChild(track);
    slider.appendChild(viewport);

    slider.dataset.bdlAnnouncementRotateInit = 'true';
    slider.classList.add('bdl-announcement-rotate');

    var index = 0;
    var interval = 4000;
    var initialDelay = 2500;
    var timer = null;
    var animationTimeout = null;
    var animating = false;
    var hoverPauseEnabled = false;

    function slideOffset(i) {
      var offset = 0;
      for (var n = 0; n < i; n++) {
        offset += slides[n].offsetHeight;
      }
      return offset;
    }

    function setViewportHeight(i, animate) {
      if (shouldUnpinAnnouncement()) {
        return;
      }

      var nextHeight = slides[i].offsetHeight;
      if (!nextHeight) {
        return;
      }

      if (animate) {
        viewport.style.height = nextHeight + 'px';
      } else {
        viewport.style.transition = 'none';
        viewport.style.height = nextHeight + 'px';
        viewport.offsetHeight;
        viewport.style.transition = '';
      }
    }

    function showSlide(i, animate) {
      if (shouldUnpinAnnouncement()) {
        return;
      }

      if (i === index && animate) {
        return;
      }

      slides.forEach(function (slide, idx) {
        slide.setAttribute('aria-hidden', idx === i ? 'false' : 'true');
      });

      if (animate) {
        animating = true;
        track.classList.add('is-animating');
      }

      setViewportHeight(i, animate);
      track.style.transform = 'translate3d(0, -' + slideOffset(i) + 'px, 0)';

      if (!animate) {
        index = i;
        return;
      }

      if (animationTimeout) {
        window.clearTimeout(animationTimeout);
      }

      animationTimeout = window.setTimeout(function () {
        animationTimeout = null;
        track.classList.remove('is-animating');
        animating = false;
        index = i;
        pinState.height = null;
        syncAnnouncementPinState();
      }, 700);
    }

    function next() {
      if (animating || shouldUnpinAnnouncement()) {
        return;
      }
      showSlide((index + 1) % slides.length, true);
    }

    function start(skipInitialDelay) {
      stop();
      if (shouldUnpinAnnouncement()) {
        return;
      }
      if (skipInitialDelay) {
        timer = window.setInterval(next, interval);
        return;
      }
      timer = window.setTimeout(function () {
        next();
        timer = window.setInterval(next, interval);
      }, initialDelay);
    }

    function stop() {
      if (timer) {
        window.clearTimeout(timer);
        window.clearInterval(timer);
        timer = null;
      }
      if (animationTimeout) {
        window.clearTimeout(animationTimeout);
        animationTimeout = null;
      }
      animating = false;
      track.classList.remove('is-animating');
    }

    function refresh() {
      if (shouldUnpinAnnouncement()) {
        return;
      }

      setViewportHeight(index, false);
      track.style.transition = 'none';
      track.style.transform = 'translate3d(0, -' + slideOffset(index) + 'px, 0)';
      track.offsetHeight;
      track.style.transition = '';
      pinState.height = null;
      syncAnnouncementPinState();
    }

    rotateController = {
      pauseForDrawer: stop,
      resumeFromDrawer: function () {
        refresh();
        start(true);
      }
    };

    showSlide(0, false);
    start();
    syncAnnouncementPinState();

    window.setTimeout(function () {
      hoverPauseEnabled = true;
    }, 500);

    slider.addEventListener('mouseenter', function () {
      if (hoverPauseEnabled) {
        stop();
      }
    });
    slider.addEventListener('mouseleave', function () {
      if (hoverPauseEnabled && !shouldUnpinAnnouncement()) {
        start(true);
      }
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(refresh, 150);
    });

    return true;
  }

  function tryInitAnnouncementRotate(attempt) {
    if (initAnnouncementRotate()) {
      return;
    }

    if (attempt >= 20) {
      return;
    }

    window.setTimeout(function () {
      tryInitAnnouncementRotate(attempt + 1);
    }, 100);
  }

  function initHeaderStickyObserver() {
    var header = document.getElementById('SiteHeader');

    if (!header || header.dataset.bdlStickyObserverInit === 'true') {
      return;
    }

    header.dataset.bdlStickyObserverInit = 'true';

    new MutationObserver(function () {
      syncAnnouncementPinState();
    }).observe(header, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  function initAnnouncementSticky() {
    syncAnnouncementPinState();
    initHeaderStickyObserver();

    if (stickyInitialized) {
      return;
    }

    stickyInitialized = true;

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) {
        return;
      }

      ticking = true;
      window.requestAnimationFrame(function () {
        syncAnnouncementPinState();
        ticking = false;
      });
    }, { passive: true });

    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        pinState.height = null;
        syncAnnouncementPinState();
      }, 150);
    });

    var html = document.documentElement;
    var drawerWasOpen = isDrawerOpen();

    new MutationObserver(function (mutations) {
      if (!window.matchMedia('(max-width: 768px)').matches) {
        drawerWasOpen = isDrawerOpen();
        return;
      }

      for (var i = 0; i < mutations.length; i++) {
        var oldClasses = mutations[i].oldValue || '';
        var hadDrawer = oldClasses.indexOf('js-drawer-open') !== -1 &&
          oldClasses.indexOf('js-drawer-open--search') === -1;
        var hasDrawer = isDrawerOpen();

        if (hadDrawer !== hasDrawer) {
          drawerWasOpen = hasDrawer;
          handleDrawerVisibilityChange(hasDrawer);
          break;
        }
      }
    }).observe(html, {
      attributes: true,
      attributeFilter: ['class'],
      attributeOldValue: true
    });

    if (drawerWasOpen) {
      handleDrawerVisibilityChange(true);
    }
  }

  function bootAnnouncementRotate() {
    tryInitAnnouncementRotate(0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bootAnnouncementRotate();
      initAnnouncementSticky();
    });
  } else {
    bootAnnouncementRotate();
    initAnnouncementSticky();
  }

  window.addEventListener('load', bootAnnouncementRotate);

  document.addEventListener('shopify:section:load', function () {
    rotateController = null;
    bootAnnouncementRotate();
    syncAnnouncementPinState();
  });
})();
